import { useOpenID } from "../openid/provider";
import { TokenViewer } from "./TokenViewer";

export const InfoBox = () => {
  const { user_info, decoded_access_token, decoded_id_token } = useOpenID();

  return (
    <div className="InfoBox">
      <TokenViewer
        title="Id Token"
        value={decoded_id_token}
        data-qa="id_token--payload"
      />
      <TokenViewer
        title="Access Token"
        value={decoded_access_token}
        data-qa="access_token--payload"
      />
      <TokenViewer
        title="User Info"
        value={!decoded_access_token ? null : user_info}
        data-qa="userinfo--payload"
      />
    </div>
  );
};
